export default "__VITE_ASSET__aZXQkP7H__"